class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // fix-logoの高さを取得してCSS変数に設定
    this.setFixLogoHeight();
    
    const mvSwiper = new Swiper(".mv__swiper", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 25,
      speed: 7500,
      allowTouchMove: false,
      centeredSlides: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });

    const peopleSwiper = new Swiper(".people-swiper", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      centeredSlides: true,
      grabCursor: true,
      allowTouchMove: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      },
    });

    // Culture section image hover
    this.initCultureImageHover();
  }

  setFixLogoHeight() {
    const $fixLogo = $(".fix-logo");
    if ($fixLogo.length === 0) return;

    const updateHeight = () => {
      const $img = $fixLogo.find("img");
      if ($img.length > 0) {
        // 画像の読み込み完了を待つ
        if ($img[0].complete) {
          const height = $img[0].offsetHeight;
          $fixLogo[0].style.setProperty("--fix-logo-height", `${height}px`);
        } else {
          $img.on("load", function() {
            const height = this.offsetHeight;
            $fixLogo[0].style.setProperty("--fix-logo-height", `${height}px`);
          });
        }
      }
    };

    // 初期実行
    updateHeight();

    // リサイズ時にも更新
    $(window).on("resize", updateHeight);
  }

  initCultureImageHover() {
    const $hoverLinks = $(".js-culture-hover");
    const $image = $(".js-culture-image");
    const $imageSource = $(".js-culture-image-source");
    const defaultImagePc = $image.attr("src");
    const defaultImageSp = $imageSource.attr("srcset");

    if ($hoverLinks.length === 0 || $image.length === 0) {
      return;
    }

    // PC版のみ画像切り替えを有効化（768px以下では無効）
    const isMobile = () => window.innerWidth <= 768;

    // 画像にトランジション用のCSSを適用（PC版のみ）
    if (!isMobile()) {
      $image.css({
        'transition': 'opacity 0.3s linear'
      });
    }

    // 現在表示されている画像のパスを保持
    let currentImagePc = defaultImagePc;

    $hoverLinks.on("mouseenter", function () {
      // スマートフォンでは画像を切り替えない
      if (isMobile()) {
        return;
      }

      const $this = $(this);

      // is-activeクラスが付いている場合はエフェクトをスキップ
      if ($this.hasClass('is-active')) {
        return;
      }

      // 他の要素からis-activeクラスを削除
      $hoverLinks.removeClass('is-active');
      
      // 現在の要素にis-activeクラスを付与
      $this.addClass('is-active');

      // is-activeが付いている要素の画像を表示
      const imagePc = $this.data("image-pc");

      // 既に表示されている画像の場合はエフェクトをスキップ
      if (imagePc && imagePc === currentImagePc) {
        return;
      }

      if (imagePc) {
        // フェードアウト → 画像変更 → フェードイン
        $image.css('opacity', '0');
        
        setTimeout(() => {
          $image.attr("src", imagePc);
          currentImagePc = imagePc; // 現在の画像を更新
          
          // 画像読み込み完了後にフェードイン
          $image.on('load', function() {
            $(this).css('opacity', '1');
          }).each(function() {
            // 既にキャッシュされている画像の場合、loadイベントが発火しないため
            if (this.complete) {
              $(this).css('opacity', '1');
            }
          });
        }, 150); // フェードアウトの半分の時間で画像を切り替え
      }
    });

    // is-activeが付いている要素の画像を常に表示する関数
    const updateImageForActive = () => {
      const $activeLink = $hoverLinks.filter('.is-active');
      
      if ($activeLink.length > 0) {
        const imagePc = $activeLink.data("image-pc");
        
        if (imagePc && imagePc !== currentImagePc) {
          // フェードアウト → 画像変更 → フェードイン
          $image.css('opacity', '0');
          
          setTimeout(() => {
            $image.attr("src", imagePc);
            currentImagePc = imagePc; // 現在の画像を更新
            
            // 画像読み込み完了後にフェードイン
            $image.on('load', function() {
              $(this).css('opacity', '1');
            }).each(function() {
              // 既にキャッシュされている画像の場合、loadイベントが発火しないため
              if (this.complete) {
                $(this).css('opacity', '1');
              }
            });
          }, 150);
        }
      } else {
        // is-activeが付いている要素がない場合はデフォルト画像に戻す
        if (currentImagePc !== defaultImagePc) {
          // フェードアウト → 画像変更 → フェードイン
          $image.css('opacity', '0');
          
          setTimeout(() => {
            $image.attr("src", defaultImagePc);
            currentImagePc = defaultImagePc; // 現在の画像を更新
            
            // 画像読み込み完了後にフェードイン
            $image.on('load', function() {
              $(this).css('opacity', '1');
            }).each(function() {
              // 既にキャッシュされている画像の場合、loadイベントが発火しないため
              if (this.complete) {
                $(this).css('opacity', '1');
              }
            });
          }, 150);
        }
      }
    };

    $hoverLinks.on("mouseleave", function () {
      // スマートフォンでは画像を切り替えない
      if (isMobile()) {
        return;
      }

      // マウスリーブ時はis-activeを削除せず、そのまま維持
      // is-activeが付いている要素の画像を常に表示する
      updateImageForActive();
    });
  }
}